let onCompleted;
let footerSwipers = {
    footer: {
        slider: false,
        elem: $('.js-footer-slider'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            slidesPerView: 1,
            simulateTouch: false,
            // autoHeight: true,
            speed: 400,
            autoplay: {
                delay: 4000
            },
            pagination: {
                el: '.js-footer-slider-dots',
                clickable: true
            }
        }
    }
}

Event.on('Window.resized', function () {
    checkSliders(footerSwipers);
});

function checkNewsletter() {
    if ($('.js-newsletter-email').val() == '') {
        $('.js-form-subscription').find('.consents-wrapper').slideUp(250);
    } else {
        $('.js-form-subscription').find('.consents-wrapper').slideDown(250);
    }

    if ($('.js-newsletter-blog-email').val() == '') {
        $('.js-form-blog-subscription').find('.consents-wrapper').slideUp(250);
    } else {
        $('.js-form-blog-subscription').find('.consents-wrapper').slideDown(250);
    }
}

$(function () {
    checkSliders(footerSwipers);

    checkNewsletter();

    $('.js-newsletter-email, .js-newsletter-blog-email').on('change keyup', function() {
        checkNewsletter();
    });

    $('.js-form-subscription').validate({
        errorPlacement: function(error, element) {
            if (element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function(form) {
            const $newsletterForm = $(form);
            const $emailInput = $newsletterForm.find('.js-newsletter-email');
            const $captchaWrapper = $newsletterForm.find('.captcha-wrapper');
            const $submitButton = $newsletterForm.find('.js-newsletter-submit');
            const $consentCheckbox = $newsletterForm.find('.js-newsletter-consents').find('input[type="checkbox"]');

            resetCaptchas();
            $captchaWrapper.slideDown();
            $emailInput.prop('readonly', true);

            onCompleted = function() {
                $captchaWrapper.slideUp(250);

                if (!$newsletterForm.valid()) {
                    $emailInput.prop('readonly', false);
                    resetCaptchas();
                    return;
                }

                $submitButton
                    .prop('disabled', true)
                    .addClass('is-loading');

                Form.ajaxPost(form, function (data) {
                    let msg = data.msg.format;

                    if (!msg) {
                        msg = data.msg;
                    }

                    Eshop.alert(msg, { type: (data.status ? 'success' : 'danger') });

                    if (!data.status) {
                        $emailInput.addClass('error').focus();
                    } else {
                        $emailInput.val('');
                    }

                    resetCaptchas();
                    $emailInput.prop('readonly', false);
                    $consentCheckbox.prop('checked', false);
                    $submitButton.prop('disabled', false).removeClass('is-loading');
                }, 'json');
            }

            return false;
        }
    });

    $('.js-form-blog-subscription').validate({
        errorPlacement: function(error, element) {
            if (element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function(form) {
            const $newsletterForm = $(form);
            const $emailInput = $newsletterForm.find('.js-newsletter-blog-email');
            const $captchaWrapper = $newsletterForm.find('.captcha-wrapper');
            const $submitButton = $newsletterForm.find('.js-newsletter-blog-submit');
            const $consentCheckbox = $newsletterForm.find('.js-newsletter-blog-consents').find('input[type="checkbox"]');

            resetCaptchas();
            $captchaWrapper.slideDown();
            $emailInput.prop('readonly', true);

            onCompleted = function() {
                $captchaWrapper.slideUp(250);

                if (!$newsletterForm.valid()) {
                    $emailInput.prop('readonly', false);
                    resetCaptchas();
                    return;
                }

                $submitButton
                    .prop('disabled', true)
                    .addClass('is-loading');

                Form.ajaxPost(form, function (data) {
                    let msg = data.msg.format;

                    if (!msg) {
                        msg = data.msg;
                    }

                    Eshop.alert(msg, { type: (data.status ? 'success' : 'danger') });

                    if (!data.status) {
                        $emailInput.addClass('error').focus();
                    } else {
                        $emailInput.val('');
                    }

                    resetCaptchas();
                    $emailInput.prop('readonly', false);
                    $consentCheckbox.prop('checked', false);
                    $submitButton.prop('disabled', false).removeClass('is-loading');
                }, 'json');
            }

            return false;
        }
    });
});
